<template>
  <div>待开发，组织结构页面</div>
</template>

<script>
export default {
  name: "Organization"
}
</script>

<style scoped>

</style>